<p-confirmDialog key="MainPage" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>Roles for School:</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText" [Disabled]="loading">
				</caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<!--Refresh Button-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddRole()">Add Role</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditRole()">Edit Role</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onCopyRole()">Copy Role</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleRole()">
			{{ ToggleText }}
		</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteRole()">Delete Role</button>
		<button [disabled]="loading" class="btn btn-success" style="margin-left: 5px" (click)="onExportUsers()">Export List of Users</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstRoles"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedRole"
		dataKey="RoleID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--Role Name-->
				<th>
					<p-columnFilter type="text" field="RoleName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Role Desc-->
				<th>
					<p-columnFilter type="text" field="RoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Defined By-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--User Level-->
				<th>
					<p-columnFilter field="UserLevelDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUserLevelDesc
								[ngModel]="value"
								[options]="lstUserLevelDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolID-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UserCountSchool-->
				<th>
					<p-columnFilter type="numeric" matchMode="gte" field="UserCountSchool" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UserCountDistrict-->
				<th>
					<p-columnFilter type="numeric" matchMode="gte" field="UserCountDistrict" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="RoleName">Role Name<p-sortIcon field="RoleName"></p-sortIcon></th>
				<th pSortableColumn="RoleDesc">Role Description<p-sortIcon field="RoleDesc"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
				<th pSortableColumn="Active">Status<p-sortIcon field="Active"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="UserCountSchool">Users in School<p-sortIcon field="UserCountSchool"></p-sortIcon></th>
				<th pSortableColumn="UserCountDistrict">Users in District<p-sortIcon field="UserCountDistrict"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-role>
			<tr [pSelectableRow]="role" [pTooltip]="role.ToolTip" tooltipPosition="bottom" showDelay="500" hideDelay="125" (dblclick)="onRowDblClick(role)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ role.RoleName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ role.RoleDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="role.DefinedByID <= 2 ? 'Red' : 'Black'">
					{{ role.DefinedByDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="role.UserLevelID == 1 ? 'Red' : 'Black'">
					{{ role.UserLevelDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="role.Active == false ? 'Red' : 'Black'">
					{{ role.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ role.SchoolName }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="role.UserCountSchool == 0 ? 'Orangered' : 'Black'"
				>
					{{ role.UserCountSchool }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="role.UserCountDistrict == 0 ? 'Orangered' : 'Black'"
				>
					{{ role.UserCountDistrict }}
				</td>

				<!-- <td
					*ngFor="let col of cols"
					style="font-weight: bold"
					[style.color]="role['DefinedByDesc'] == 'System' && col.field == 'DefinedByDesc' ? 'red' : 'black'"
				>
					{{ role[col.field] }}
				</td> -->
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
